export const replaceEncodedReturnToDomain = (
  url: string,
  newReturnTo: string
): string => {
  const urlDecoded = decodeURIComponent(url);
  const newURL = urlDecoded.replace(
    /returnTo=[^&]+/,
    `returnTo=${encodeURIComponent(newReturnTo)}`
  );

  return newURL;
};
